{
  "aiGeneratedAnswer": "إجابة تم إنشاؤها بواسطة الذكاء الاصطناعي",
  "allCategories": "جميع الفئات ",
  "appliedFiltersToCurrentSearch": "تم تطبيق الفلاتر على البحث الحالي",
  "apply": "تطبيق",
  "applyFilters": "تطبيق الفلاتر",
  "autocompleteOptionsFound_few": "تم العثور على {{count}} خيارات للإكمال التلقائي {{label}}.",
  "autocompleteOptionsFound_many": "تم العثور على {{count}} خيارًا للإكمال التلقائي {{label}}.",
  "autocompleteOptionsFound_one": "تم العثور على خيار واحد للإكمال التلقائي {{label}}.",
  "autocompleteOptionsFound_other": "تم العثور على {{count}} خيار للإكمال التلقائي {{label}}.",
  "autocompleteOptionsFound_two": "تم العثور على خيارين للإكمال التلقائي {{label}}.",
  "autocompleteOptionsFound_zero": "لم يتم العثور على أي خيارات للإكمال التلقائي.",
  "autocompleteSuggestion": "اقتراح الإكمال التلقائي: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "تم العثور على {{count}} اقتراحات.",
  "autocompleteSuggestionsFound_many": "تم العثور على {{count}} اقتراحًا.",
  "autocompleteSuggestionsFound_one": "تم العثور على اقتراح واحد.",
  "autocompleteSuggestionsFound_other": "تم العثور على {{count}} اقتراح.",
  "autocompleteSuggestionsFound_two": "تم العثور على اقتراحين.",
  "autocompleteSuggestionsFound_zero": "لم يتم العثور على أي اقتراحات.",
  "basedOnYourDevice": " (استنادًا إلى جهازك)",
  "basedOnYourInternetAddress": " (استنادًا إلى عنوان الإنترنت الخاص بك)",
  "categoriesText_one": "الفئة التالية تحتوي على نتائج لـ - <strong>{{query}}</strong>",
  "categoriesText_other": "الفئات التالية تحتوي على نتائج لـ - <strong>{{query}}</strong>",
  "clearAll": "مسح الكل",
  "clearMinAndMax": "مسح الحد الأدنى والأقصى",
  "clearTheRangeToSelectOptions": "امسح النطاق لاختيار الخيارات.",
  "clearTheSearchBar": "امسح شريط البحث",
  "conductASearch": "إجراء بحث",
  "currentLocation": "الموقع الحالي",
  "didYouMean": "هل كنت تقصد <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "عند توفر نتائج الإكمال التلقائي، استخدم الأسهم للأعلى والأسفل للتنقل واضغط Enter للاختيار.",
  "feedback": "ملاحظات",
  "invalidRange": "نطاق غير صالح",
  "max": "الحد الأقصى",
  "min": "الحد الأدنى",
  "navigateToTheNextResultsPage": "انتقل إلى صفحة النتائج التالية",
  "navigateToThePreviousResultsPage": "انتقل إلى صفحة النتائج السابقة",
  "noAutocompleteOptionsFound": "لم يتم العثور على خيارات للإكمال التلقائي.",
  "noAutocompleteSuggestionsFound": "لم يتم العثور على اقتراحات.",
  "noResultsFoundIn": "لم يتم العثور على نتائج في {{currentVerticalLabel}}.",
  "pagination": "ترقيم الصفحات",
  "readMoreAbout": "اقرأ المزيد عن <a>{{name}}</a>",
  "recentSearch": "بحث حديث: {{query}}",
  "recentSearchesFound_few": "تم العثور على {{count}} عمليات بحث.",
  "recentSearchesFound_many": "تم العثور على {{count}} عملية بحث.",
  "recentSearchesFound_one": "تم العثور على عملية بحث واحدة.",
  "recentSearchesFound_other": "تم العثور على {{count}} عملية بحث.",
  "recentSearchesFound_two": "تم العثور على عمليتي بحث.",
  "recentSearchesFound_zero": "لم يتم العثور على عمليات بحث حديثة.",
  "removeFilter": "إزالة الفلتر «{{displayName}}»",
  "resultPreview": "معاينة النتيجة: {{value}}",
  "resultPreviewsFound_few": "تم العثور على {{count}} معاينات.",
  "resultPreviewsFound_many": "تم العثور على {{count}} معاينة.",
  "resultPreviewsFound_one": "تم العثور على معاينة واحدة.",
  "resultPreviewsFound_other": "تم العثور على {{count}} معاينة.",
  "resultPreviewsFound_two": "تم العثور على معاينتين.",
  "resultPreviewsFound_zero": "لم يتم العثور على أي معاينات.",
  "resultsCountText_few": "{{count}} نتائج",
  "resultsCountText_many": "{{count}} نتيجة",
  "resultsCountText_one": "نتيجة واحدة",
  "resultsCountText_other": "{{count}} نتيجة",
  "resultsCountText_two": "نتيجتان",
  "resultsCountText_zero": "لا توجد نتائج",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} من أصل {{resultsCount}} نتيجة",
  "searchHere": "ابحث هنا…",
  "showLess": "عرض أقل",
  "showMore": "عرض المزيد",
  "showingAllInstead": "يتم عرض جميع نتائج {{currentVerticalLabel}} بدلاً من ذلك.",
  "sources_few": "مصادر ({{count}})",
  "sources_many": "مصدر ({{count}})",
  "sources_one": "مصدر",
  "sources_other": "مصدر ({{count}})",
  "sources_two": "مصدران",
  "sources_zero": "لا توجد مصادر",
  "submitSearch": "تنفيذ البحث",
  "suggestionResultsCount_few": "{{label}} - {{count}} نتائج",
  "suggestionResultsCount_many": "{{label}} - {{count}} نتيجة",
  "suggestionResultsCount_one": "{{label}} - نتيجة واحدة",
  "suggestionResultsCount_other": "{{label}} - {{count}} نتيجة",
  "suggestionResultsCount_two": "{{label}} - نتيجتان",
  "suggestionResultsCount_zero": "{{label}} - لا توجد نتائج",
  "thankYouForYourFeedback": "شكرًا لملاحظاتك!",
  "thisAnsweredMyQuestion": "نعم، هذا أجاب على سؤالي",
  "thisDidNotAnswerMyQuestion": "لا، هذا لم يجب على سؤالي",
  "unselectAnOptionToEnterInARange": "قم بإلغاء تحديد خيار لإدخال نطاق.",
  "updateYourLocation": "تحديث موقعك",
  "useCurrentLocation": "استخدام الموقع الحالي",
  "useMyLocation": "استخدم موقعي",
  "viewAll": "عرض الكل",
  "viewDetails": "عرض التفاصيل"
}
